import { requests } from "../../../../api/agent";

export default {
  getPotentialRepeatedReOrgAppeals: (values) => requests.post("/Appeal/getPotentialRepeatedReOrgAppeals", values)
};
